export default __webpack_public_path__ + "static/media/logo.0a66db27.svg";